export default "__VITE_ASSET__DszbWqtb__"